    
import {combineReducers} from 'redux'
import allLayoutReducers from '../Areas/Layout/reducers';
import allPlanTemplateReducers from '../Areas/PlanTemplate/reducers';
import allLoginReducers from '../Areas/Login/reducers';
import allPlanHandleReducers from '../Areas/PlanHandle/reducers';
import allMenuAuthorizationReducers from '../Areas/MenuAuthorization/reducers';
import allMenuRoleReducer from '../Areas/MenuRole/reducers';
import allUserMenuReducer from '../Areas/MenuUser/reducers';
import allDashboardReducer from '../Areas/Dashboard/reducers';
import allConfirmPageReducers from '../Areas/HomeConfirm/reducers';
//IndexImportHygen
const allReducers = combineReducers({
    allLayoutReducers,
    allPlanTemplateReducers,
    allLoginReducers,
    allPlanHandleReducers,
    allMenuAuthorizationReducers,
    allMenuRoleReducer,
    allUserMenuReducer,
    allDashboardReducer,
    allConfirmPageReducers,
    //IndexUsingHygen
})

export default allReducers;
